import React from 'react';
import { Navigate } from 'react-router-dom';

const Orders: React.FC = () => {
    return <Navigate to="/?orders=open" replace />;
};

export default Orders;
